import { createApi } from '@reduxjs/toolkit/query/react';
import { authRequest } from '../store/authorizedRequests';
import { DEEP_ANALYSIS_API_URL } from '../settings/config';

const deepAnalysisBaseUrl = `${DEEP_ANALYSIS_API_URL}`;
const DEEP_ANALYSIS_REFETCH_TIME = 7200;

export const deepAnalysisApi = createApi({
    reducerPath: 'api.deepAnalysis',

    keepUnusedDataFor: DEEP_ANALYSIS_REFETCH_TIME,

    tagTypes: [
        'WebsiteIndexEntries',
        'Favicons',
        'ServiceableUrls',
        'ServiceableUrlsInCluster',
        'ServiceableUrlsCount',
        'FailedChecks',
        'DomainChecks',
        'AffectedUrls',
        'DomainAudits',
        'UrlAudits',
        'ActiveProcesses',
        'UrlClusters',
        'TrackedWebsites'
    ],

    baseQuery: async (args, api, extraOptions) => {
        const { url, method, body, signal } = args;
        const { dispatch, getState } = api;
        try {
            const data = await authRequest(deepAnalysisBaseUrl.concat(url), dispatch, getState, {
                method: method,
                body: JSON.stringify(body),
                signal: signal,
            });

            if (typeof data === 'undefined') {
                return { data: null };
            }

            return { data };
        } catch (error) {
            return { error };
        }
    },

    endpoints: (builder) => ({}),
});
